import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { SCREENS } from 'containercomponents/Modals/LoginModal/login-modal.consts';
import { MODALS } from 'containercomponents/Modals/modal.consts';
import queryString from 'query-string';
import { showModal } from 'store/redux/modals/actions';
import { selectIsUserLoggedIn } from 'store/redux/user/selectors';

export function useUserIsLogged() {
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const init = useCallback(async () => {
    if (isUserLoggedIn) return;

    // user not logged in case
    let query;
    try {
      const queryParams = queryString.parse(location.search);
      const decodedQueryString = window.atob(queryParams?.data as string);
      query = queryString.parse(decodedQueryString);
    } catch (e) {
      console.error(e);
    }

    dispatch(
      showModal(MODALS.LOGIN, {
        currentScreen: SCREENS.LOGIN_SCREEN,
        redirectToHomeOnHide: true,
        loginScreenProps: {
          email: query?.email,
        },
        onSucessfulLogin: async () => {
          history.push(location.pathname);
          history.go(0);
        },
      }),
    );
  }, [dispatch, history, isUserLoggedIn, location.pathname, location.search]);

  useEffect(() => {
    init();
  }, [isUserLoggedIn, init]);
}
